<p-button [label]="label" type="button" *ngIf="!isLoading" [disabled]="disabled" (onClick)="onClicked()"></p-button>
<p-button icon="pi pi-spin pi-spinner" class="no-pointer regular-button" *ngIf="isLoading"></p-button>